<template>
  <div style="min-width:1100px">
    <p style="text-align: center;">
      <!-- 需求管理 -->
      <span class="systemFont1">{{ $t("demandMgt.demandMgtTitle") }}</span>
    </p>
    <el-row style="top: 17px;">
      <el-col :offset="1" :span="22" style="text-align: left;">
        <!-- 模糊查询 -->
        <el-form
          ref="queryForm"
          :model="queryForm"
          class="systemFont1"
          label-position="right"
          label-width="100px"
        >
          <el-row>
            <!-- 工作需求标题 -->
            <el-col :offset="1" :span="6">
              <el-form-item :label="$t('demandMgt.jobTitle')">
                <el-input
                  v-model="queryForm.jobTitle"
                  :placeholder="$t('demandMgt.jobTitle')"
                  clearable
                  maxlength="125"
                  name="queryForm.jobTitle"
                  size="courseSelect"
                  type="text"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 工作时间 -->
            <el-col :span="7">
              <el-form-item
                :label="$t('demandMgt.jobTime')"
                style="margin-bottom: 22px"
              >
                <el-date-picker
                  v-model="queryForm.jobTime"
                  :end-placeholder="$t('demandMgt.endDate')"
                  :range-separator="$t('demandMgt.to')"
                  :start-placeholder="$t('demandMgt.startDate')"
                  format="yyyy-MM-dd"
                  size="small"
                  style="width:100%"
                  type="daterange"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!--状态-->
            <el-col :span="5">
              <el-form-item :label="$t('demandMgt.status')">
                <el-select
                  v-model="queryForm.status"
                  :placeholder="$t('common.pleaseSelect')"
                  clearable
                  size="courseSelect"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in statueOpt"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="width: 200px;">
              <!-- 查询 -->
              <el-button
                class="submitButton"
                style="width:80px;margin-left:15px"
                type="submit"
                @click="init(true)"
              ><span>{{ $t("common.query") }}</span>
              </el-button>
              <!-- 重置 -->
              <el-button class="buttonWidth" type="submit" @click="reset"
              ><span>{{ $t("common.reset") }}</span>
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="top: 17px;">
      <el-col :offset="1" :span="22" style="text-align: left;">
        <el-row>
          <el-col>
            <!-- 新增 -->
            <el-button
              class="submitButton"
              style="width: 100px"
              type="submit"
              @click="
                $router.push({
                  path: '/views/ResourceBaseManagement/DemandMgt/Edit',
                  query: {
                    titleHead: 'add',
                    //模糊查询
                    queryForm: JSON.stringify(queryForm),
                    // 当前页
                    currentPageCo: currentPageCo,
                    // 页数
                    pageSizeCo: pageSizeCo,
                    // 总数
                    totalCo: totalCo
                  }
                })
              "
            ><span>{{ $t("demandMgt.postJobRequirements") }}</span>
            </el-button>
          </el-col
          >
        </el-row>
      </el-col>
    </el-row>
    <!-- 需求管理一览 -->
    <el-row style="top: 17px ;">
      <el-col :offset="1" :span="22">
        <el-table :data="tableData">
          <!-- 工作需求标题 -->
          <el-table-column
            :label="$t('demandMgt.jobTitle')"
            align="left"
            min-width="224"
            prop="jobTitle"
          >
          </el-table-column>
          <!-- 需要人数 -->
          <el-table-column
            :label="$t('demandMgt.numberOfWorkers')"
            align="right"
            prop="numberOfWorkers"
            min-width="86"
          >
          </el-table-column>
          <!-- 工作时间 -->
          <el-table-column
            :label="$t('demandMgt.jobTime')"
            align="center"
            prop="startTime"
            min-width="160"
          >
            <template slot-scope="scope">
              <span>{{dateFormat(scope.row.startTime, "YYYY-MM-DD HH:mm")}}</span>
            </template>
          </el-table-column>
          <!-- 发送人数 -->
          <el-table-column
            :label="$t('demandMgt.countSend')"
            align="right"
            prop="countSend"
            min-width="86"
          >
          </el-table-column>
          <!-- 接受工作人数 -->
          <el-table-column
            :label="$t('demandMgt.countAccept')"
            align="right"
            prop="countAccept"
            min-width="86"
          >
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            :label="$t('demandMgt.status')"
            align="center"
            prop="status"
            min-width="80"
          >
            <template slot-scope="scope">
              <span :style="`color: ${statusFormat(scope.row).color}`">{{
                  statusFormat(scope.row).value
                }}</span>
            </template>
          </el-table-column>
          <!-- 最新发布时间 -->
          <el-table-column
            :label="$t('demandMgt.updateTime')"
            align="center"
            prop="publishTime"
            min-width="160"
          >
            <template slot-scope="scope">
              {{ dateFormat(scope.row.publishTime, "YYYY-MM-DD HH:mm") }}
            </template>
          </el-table-column>
          <!-- 操作 状态: 0未发布、1已发布、2已取消、3已完成、99已删除-->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="180"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- 编辑 -->
              <el-button
                v-if="scope.row.status === 0||scope.row.status === 1||scope.row.status === 2"
                size="text"
                @click="
                  $router.push({
                    path: '/views/ResourceBaseManagement/DemandMgt/Edit',
                    query: {
                      titleHead: 'edit',
                      demandId: scope.row.demandId,
                      //模糊查询
                      queryForm: JSON.stringify(queryForm),
                      // 当前页
                      currentPageCo: currentPageCo,
                      // 页数
                      pageSizeCo: pageSizeCo,
                      // 总数
                      totalCo: totalCo
                    }
                  })
                "
              >{{ $t("demandMgt.publish") + '/' + $t("common.edit") }}
              </el-button>
              <!-- 完成 -->
              <el-button
                v-if="scope.row.status === 1"
                size="text"
                @click="updateStatus(scope.row, 3)"
              >{{ $t("demandMgt.finish") }}
              </el-button>
              <!-- 详情 -->
              <el-button
                v-if="scope.row.status === 3"
                size="text"
                @click="
                  $router.push({
                    path: '/views/ResourceBaseManagement/DemandMgt/Detail',
                    query: {
                      titleHead: 'edit',
                      demandId: scope.row.demandId,
                      //模糊查询
                      queryForm: JSON.stringify(queryForm),
                      // 当前页
                      currentPageCo: currentPageCo,
                      // 页数
                      pageSizeCo: pageSizeCo,
                      // 总数
                      totalCo: totalCo
                    }
                  })
                "
              >{{ $t("common.details") }}
              </el-button>
              <!-- 删除 -->
              <el-button
                v-if="scope.row.status === 0"
                size="text"
                style="color: #FD5B4D"
                @click="updateStatus(scope.row, 99)"
              >{{ $t("common.delete") }}
              </el-button>
              <!-- 取消 -->
              <el-button
                v-if="checkClean(scope.row)"
                size="text"
                style="color: #FD5B4D"
                @click="updateStatus(scope.row, 2)"
              >{{ $t("common.cancel") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                :current-page.sync="currentPageCo"
                :page-size="pageSizeCo"
                :page-sizes="[10, 20, 50]"
                :total="totalCo"
                layout="total, sizes, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
import log from "../../Sys/Log.vue";

export default {
  name: "DemandMgt",
  data() {
    return {
      userId: "",
      // 一览数据
      tableData: [],
      // 查询条件
      queryForm: {
        jobTitle: "",
        status: "",
        jobTime: [],
      },
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 10,
      totalCo: 0,
      statueOpt: [
        // 未发布
        {key: 0, value: this.$t('demandMgt.unpublished'), color: '#FD5B4D'},
        // 已发布
        {key: 1, value: this.$t('demandMgt.published'), color: '#00BAF3'},
        // 已取消
        {key: 2, value: this.$t('demandMgt.canceled'), color: '#FD5B4D'},
        // 已完成
        {key: 3, value: this.$t('demandMgt.done'), color: '#02D764'},
      ]
    };
  },
  watch: {
    // 监听上课时间区段
    "queryForm.jobTitle"(newVal) {
      if (newVal == "") {
        console.log(newVal)
        this.queryForm.jobTitle = "",
        this.init(true);
      }
    },
    // 监听课程名称是否为空
    "queryForm.status"(newVal) {
      if (newVal == "" && newVal!==0) {
        this.queryForm.status = "";
        this.init(true);
      }
    },
    // 监听课程名称是否为空
    "queryForm.jobTime"(newVal) {
      if (newVal == null) {
        this.queryForm.jobTime =  [];
        this.init(true);
      }
    }
  },
  methods: {
    checkClean(row){
      if (row.status === 1){
        return true;
      } else if (row.status === 3){
        let startTime = new Date(row.startTime);
        if (startTime.getTime() > new Date().getTime()) {
          return true
        }
      }
      return false;
    },
    statusFormat(row) {
      return this.statueOpt.find(item => item.key === row.status)
    },
    // 格式化发起日期
    dateFormat(time, format) {
      if (time) {
        return moment(time).format(format);
      } else {
        return "-";
      }
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.tableData == undefined || this.tableData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 重置搜索表单
    reset() {
      this.queryForm = {
        jobTitle: "",
        status: "",
        jobTime: [],
      };
      this.init(true);
    },
    // 初始化一览数据
    init(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      let url = "/api/demand/getList";
      this.$http
        .post(url, {
          //模糊查询
          ...this.queryForm,
          // 开始日期
          startDateString: this.queryForm.jobTime[0],
          // 截止日期
          endDateString: this.queryForm.jobTime[1],
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.tableData = [];
            } else {
              // 总数取值
              this.totalCo = response.data.data[0].totalCo;
              // 渲染页面
              this.tableData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 发布、删除
    updateStatus(row, status) {
      let msg;
      switch (status) {
        case 1:
          // 确定要发布吗
          msg = this.$t('demandMgt.msg1');
          break
        case 2:
          // 确定要取消吗
          msg = this.$t('demandMgt.msg2');
          break
        case 3:
          // 确定要完成吗
          msg = this.$t('demandMgt.msg3');
          break
        case 99:
          // 确定要删除吗
          msg = this.$t('demandMgt.msg4');
          break
      }
      this.$confirm(
        msg,
        {
          // 确定
          confirmButtonText: this.$t("common.confirm"),
          // 取消
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let url = "/api/demand/updateStatus";
        this.$http
          .post(url, {
            ...row,
            status,
            updateUser: localStorage.userId
          })
          .then(rep => {
            loading.close()
            this.$message({
              type: "success",
              message: this.$t("p0433.operationSuccess")
            });
            this.init(false);
          })
          .catch(err => {
            loading.close()
            this.$message.error(err.data.message);
            console.log(err);
          });
      });
    }
  },
  mounted() {
    if (this.$route.query.currentPageCo) {
      this.currentPageCo = Number(this.$route.query.currentPageCo);
    }
    if (this.$route.query.totalCo) {
      this.totalCo = Number(this.$route.query.totalCo);
    }
    if (this.$route.query.pageSizeCo) {
      this.pageSizeCo = Number(this.$route.query.pageSizeCo);
    }
    if (this.$route.query.queryForm) {
      this.queryForm = JSON.parse(this.$route.query.queryForm);
    }
    let path = this.$route.path; //先获取路由路径
    this.$router.replace(path); //再跳转路由路径，query参数没带过去，所以被清除了
    this.init(false);
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.preSpecificContent {
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  color: #666666;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0px;
}

>>> .el-input--courseSelect .el-input__inner {
  height: 32px !important;
}

.el-button--submit {
  height: 32px;
}

>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}

//弹窗样式
>>> .roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(80vh - 140px);
}

//弹窗样式
>>> .add_roll-dialog {
  .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 140px);
  }
}

.submitButton {
  height: 32px;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/ResourceBaseManagement/DemandMgt/Index.vue